/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { cssProps } from '@oracle/oraclejet-cssprops';
import { mergeInterpolations } from '../utils/UNSAFE_mergeInterpolations';

// TODO -  Expose props once vertical orientation is supported
type DividerProps = {
  /**
   * Divider's orientation.
   */
  orientation?: 'horizontal';
};

const styles = {
  orientation: {
    horizontal: cssProps`${{
      display: 'block',
      width: '100%',
      height: '0',
      borderColor: 'var(--oj-c-PRIVATE-DO-NOT-USE-core-divider-color)',
      borderStyle: 'solid',
      borderWidth: '1px 0 0 0',
      fontSize: '0',
      lineHeight: '0'
    }}`
  }
};

const interpolations = [
  ({ orientation = 'horizontal' }: Pick<DividerProps, 'orientation'>) => ({
    class: styles.orientation[orientation]
  })
];

const styleInterpolations = mergeInterpolations<DividerProps>(interpolations);

// TODO - Support vertical orientation
export function Divider() {
  const { class: cls } = styleInterpolations({ orientation: 'horizontal' });

  // TODO - Check  with archs if this should be a polymorphic component and if the answer is yes, implement it
  return <span class={cls} role="separator" aria-orientation="horizontal"></span>;
}
